<template>
  <div
    class="pick-card hstack cursor-pointer"
    :class="{ 'pick-card-filled': filled, 'pick-card-lg': large }"
    @click="goDetail"
    >
    <img
      :src="$commonUtils.getImageUrl(story.story_image1 ? story.story_image1 : 'story/no_image.png')"
      class="pick-card-img of-cover flex-shrink-0"
      />

    <div class="vstack min-w-0 flex-grow-1 pick-card-body">
      <div class="hstack align-items-center">
        <span class="pick-badge flex-shrink-0">포인핸드 Pick</span>
        <span v-if="story.pick_date" class="pick-date ml-2 nw-dot">{{ story.pick_date }}</span>
      </div>

      <p class="pick-title nw-dot">{{ story.story_title }}</p>
      <p class="pick-content nw-2-dot">{{ contentText }}</p>

      <div class="hstack align-items-center pick-writer">
        <img
          :src="$commonUtils.getImageUrl(story.user_image ? story.user_image : 'profile_default.jpg')"
          class="pick-profile of-cover flex-shrink-0"
          />
        <span class="pick-nickname nw-dot ml-2">{{ story.user_id }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PickStoryCard',
  props: {
    story: { type: Object, required: true },
    // 홈 카드처럼 밝은 주황 배경으로 강조할지 여부
    filled: { type: Boolean, default: false },
    // 홈 강조 카드처럼 사진을 더 크게 표시할지 여부
    large: { type: Boolean, default: false },
  },
  computed: {
    // HTML 태그 제거 + 공백 정리 (앱과 동일하게 2줄 미리보기)
    contentText() {
      const c = this.story && this.story.story_contents1 ? this.story.story_contents1 : '';
      return c.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    },
  },
  methods: {
    goDetail() {
      if (!this.story || !this.story.story_idx) return;
      this.$router.push({ name: 'StoryDetail', params: { idx: this.story.story_idx } });
    },
  },
};
</script>

<style scoped>
@import "@/css/common.css";

.pick-card {
  align-items: center;
  padding: 12px;
  border-radius: 12px;
}

/* 홈 강조 카드 (밝은 주황 배경) */
.pick-card-filled {
  background-color: #FFF1E0;
}

.pick-card-img {
  width: 112px;
  height: 112px;
  border-radius: 8px;
  background-color: #F2F2F2;
}

/* 홈 강조 카드: 사진을 더 크게 (PC) */
.pick-card-lg .pick-card-img {
  width: 240px;
  height: 240px;
}

/* 홈 강조 카드: PC(≥1025px)에서만 글자/내부 여백 키움 */
@media (min-width: 1025px) {
  .pick-card-lg {
    padding: 20px;
  }
  .pick-card-lg .pick-card-body {
    margin-left: 16px;
  }
  .pick-card-lg .pick-badge { font-size: 12px; }
  .pick-card-lg .pick-date { font-size: 12px; }
  .pick-card-lg .pick-title { font-size: 17px; }
  .pick-card-lg .pick-content { font-size: 14px; }
  .pick-card-lg .pick-nickname { font-size: 13px; }
}

.pick-card-body {
  margin-left: 12px;
  min-width: 0;
  justify-content: center;   /* 사진 높이에 맞춰 글자 라인을 세로 중앙 정렬 */
}

.pick-badge {
  background-color: #FF7A00;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 8px;
  line-height: 1.2;
  white-space: nowrap;
}

.pick-date {
  color: #666666;
  font-size: 11px;
}

.pick-title {
  margin-top: 6px;
  font-size: 14px;
  font-weight: 700;
  color: #111111;
}

.pick-content {
  margin-top: 3px;
  font-size: 12px;
  color: #666666;
}

.pick-writer {
  margin-top: 6px;
}

.pick-profile {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #EEEEEE;
}

.pick-nickname {
  font-size: 12px;
  color: #666666;
}

@media (max-width: 1024px) {
  .pick-card-img {
    width: 112px;
    height: 112px;
  }
  .pick-card-lg .pick-card-img {
    width: 124px;
    height: 124px;
  }
}
</style>
